// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1017":"57addb94","6880":"08dcba18","7043":"282d5d66"}[chunkId] + ".chunk.css";
};